<template>
  <div class="talent-map">
    <el-card shadow="hover" class="layout-padding-auto">
      <div class="system-user-search mb15">
        <div class="system-user-search mb15">
          <el-input
            v-model="queryData.searchValue"
            size="small"
            placeholder="请输入"
            style="max-width: 180px"
          >
          </el-input>
          <el-button size="small" type="primary" class="ml10" @click="getList">
            <el-icon>
              <ele-Search />
            </el-icon>
            查询
          </el-button>
          <el-button
            size="small"
            type="success"
            class="ml10"
            @click="onOpenEditDialog({})"
          >
            <el-icon>
              <ele-FolderAdd />
            </el-icon>
            新增
          </el-button>
        </div>
      </div>
      <el-table :data="tableData" v-loading="loading" style="width: 100%">
        <el-table-column type="index" label="序号" width="50" align="center" />
        <el-table-column
          prop="Name"
          label="名称"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="Location"
          label="地址"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="Phone"
          label="联系电话"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="Description"
          label="描述"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="Type"
          label="类型"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="Longitude"
          label="经/纬度"
          show-overflow-tooltip
          align="center"
        >
          <template #default="scope">
            {{ scope.row.Longitude }}，{{ scope.row.Latitude }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template #default="scope">
            <el-button
              size="small"
              text
              type="text"
              @click="onOpenEditDialog(scope.row)"
              >修改</el-button
            >
            <el-button
              size="small"
              text
              type="text"
              @click="onRowDel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        class="mt15"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        v-model:current-page="queryData.page"
        background
        v-model:page-size="queryData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <editDialog ref="editDialog" @refresh="getList" />
  </div>
</template>
<script>
import { GetMapLocationPage, DeleteMapLocation } from "@/api/talentMap/index";
import editDialog from "./editDialog.vue";
export default {
  name: "TalentMap",
  components: { editDialog },
  data() {
    return {
      tableData: [
        {
          Name: "测试点位",
          Location: "string",
          Phone: "string",
          Description: "string",
          Type: "string",
          Latitude: 0,
          Longitude: 0,
        },
      ],
      queryData: {
        page: 1,
        pageSize: 10,
        searchValue: "",
      },
      total: 0,
      loading: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    onHandleSizeChange(val) {
      this.queryData.pageSize = val;
      this.getList();
    },
    onHandleCurrentChange(val) {
      this.queryData.page = val;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const res = await GetMapLocationPage(this.queryData);
      if (res.data.status) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
      this.loading = false;
    },
    onOpenEditDialog(row) {
      console.log(this.$refs.editDialog);
      this.$refs.editDialog.openDialog(row, "编辑");
    },
    onRowDel(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let params = { Id: row.Id };
          DeleteMapLocation(params).then((res) => {
            console.log("res", res);
            if (res.data.status === 200) {
              this.getList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "info",
                message: "删除失败!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
